module.exports = __webpack_public_path__ + "static/img/mechanism-5.67cf2d41.png";